import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
  CircularProgress,
  AlertColor,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { Owner } from "./BuildingEditPage";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";

export type OwnerSelectionProps = {
  openOwnerModal: boolean;
  setOpenOwnerModal: (open: boolean) => void;
  handleSelectOwner: (owner: Owner | undefined) => void;
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAlertSeverity: React.Dispatch<React.SetStateAction<AlertColor>>;
  setSnackbarMessage: React.Dispatch<React.SetStateAction<string>>;
};

export const OwnerSelectionModal: React.FC<OwnerSelectionProps> = ({
  openOwnerModal,
  setOpenOwnerModal,
  handleSelectOwner,
}) => {
  const [owners, setOwners] = useState<Owner[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (openOwnerModal) {
      const fetchOwners = async () => {
        setLoading(true); // ローディング開始
        // JWTトークンを取得します
        const jwtToken = await getJwtTokenFromIdToken();
        try {
          const response = await fetch(
            process.env.REACT_APP_API_ENDPOINT + "/owners",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: jwtToken,
              },
            }
          );
          setOwners([]); // 前の情報をリセット
          const data = await response.json();
          // isEnabled が true のオーナーのみセットする
          setOwners(
            data.owners.filter(
              (owner: { isEnabled: boolean }) => owner.isEnabled
            )
          );
        } catch (error) {
          console.error("Error fetching owners:", error);
        } finally {
          setLoading(false); // ローディング終了
        }
      };

      fetchOwners();
    }
  }, [openOwnerModal]);

  return (
    <Dialog open={openOwnerModal} onClose={() => setOpenOwnerModal(false)}>
      <DialogTitle>LAD契約者（オーナー）選択</DialogTitle>
      <DialogContent>
        <Autocomplete
          options={owners}
          getOptionLabel={(option) => option.ownerName}
          style={{ width: 400 }}
          onChange={(event, newValue) => {
            if (newValue) {
              handleSelectOwner(newValue);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="LAD契約者（オーナー）名検索"
              variant="outlined"
            />
          )}
        />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <List>
            {owners.map((owner, index) => (
              <ListItem
                button
                key={index}
                onClick={() => handleSelectOwner(owner)}
              >
                <ListItemText>
                  <Typography variant="body1" noWrap>
                    {owner.ownerName}
                  </Typography>
                  <Typography variant="body2" noWrap>
                    {owner.representativeName}
                  </Typography>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpenOwnerModal(false)}>閉じる</Button>
      </DialogActions>
    </Dialog>
  );
};
